import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import Slider from 'react-slick';

import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

class FoundationRequest extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

		this.state = {
			
      orgName: '',
      orgMission: '',
      eventDescription: '',
      donationUsed: '',
      donationBenefits: '',
      hearAbout: '',
      eventLocationCity: '',
      eventLocationState: '',
      eventLocationVenue: '',
      eventLocationDate: '',
      eventLocationTime: '',
      eventGuestExpected: '',
      otherJewelers: null,
      otherDonation: '',
      priorDonation: null,
      priorDonationWhat: '',
      contactName: '',
      contactEmail: '',
      contactPhone: '',
      taxId: '',

      errorOrgName: false,
      errorOrgMission: false,
      errorEventDescription: false,
      errorDonationUsed: false,
      errorDonationBenefits: false,
      errorHearAbout: false,
      errorEventLocationCity: false,
      errorEventLocationState: false,
      errorEventLocationVenue: false,
      errorEventLocationDate: false,
      errorEventLocationTime: false,
      errorEventGuestExpected: false,
      errorOtherJewelers: false,
      errorOtherDonation: false,
      errorPriorDonation: false,
      errorPriorDonationWhat: false,
      errorContactName: false,
      errorContactEmail: false,
      errorContactPhone: false,
      errorTaxId: false,
		}
	}

  componentDidMount() {
    this.props.commonModalResize();
  }

  changeOrgName(evt) {
    this.setState({ orgName: evt.target.value });
  }

  changeOrgMission(evt) {
    this.setState({ orgMission: evt.target.value });
  }

  changeOrgDescription(evt) {
    this.setState({ eventDescription: evt.target.value });
  }

  changeDonationUsed(evt) {
    this.setState({ donationUsed: evt.target.value });
  }

  changeDonationBenefits(evt) {
    this.setState({ donationBenefits: evt.target.value });
  }

  changeHearAbout(evt) {
    this.setState({ hearAbout: evt.target.value });
  }

  changeEventLocationCity(evt) {
    this.setState({ eventLocationCity: evt.target.value });
  }

  changeEventLocationState(evt) {
    this.setState({ eventLocationState: evt.target.value });
  }

  changeEventLocationVenue(evt) {
    this.setState({ eventLocationVenue: evt.target.value });
  }

  changeEventLocationDate(evt) {
    this.setState({ eventLocationDate: evt.target.value });
  }

  changeEventLocationTime(evt) {
    this.setState({ eventLocationTime: evt.target.value });
  }

  changeEventGuestExpected(evt) {
    this.setState({ eventGuestExpected: evt.target.value });
  }

  changeOtherJewelers(evt) {
    this.setState({ otherJewelers: evt.target.value });
  }

  changeOtherDonation(evt) {
    this.setState({ otherDonation: evt.target.value });
  }

  changePriorDonation(evt) {
    this.setState({ priorDonation: evt.target.value });
  }

  changePriorDonationWhat(evt) {
    this.setState({ priorDonationWhat: evt.target.value });
  }

  changeContactName(evt) {
    this.setState({ contactName: evt.target.value });
  }

  changeContactEmail(evt) {
    this.setState({ contactEmail: evt.target.value });
  }

  changeContactPhone(evt) {
    this.setState({ contactPhone: evt.target.value });
  }

  changeTaxId(evt) {
    this.setState({ taxId: evt.target.value });
  }

  validateAll() {
    return true;
  }

  submitRequest() {
    if(this.validateAll()) {

      let foundationData = {
        orgName: this.state.orgName,
        orgMission: this.state.orgMission,
        eventDescription: this.state.eventDescription,
        donationUsed: this.state.donationUsed,
        donationBenefits: this.state.donationBenefits,
        hearAbout: this.state.hearAbout,
        eventLocationCity: this.state.eventLocationCity,
        eventLocationState: this.state.eventLocationState,
        eventLocationVenue: this.state.eventLocationVenue,
        eventLocationDate: this.state.eventLocationDate,
        eventLocationTime: this.state.eventLocationTime,
        eventGuestExpected: this.state.eventGuestExpected,
        otherJewelers: this.state.otherJewelers,
        otherDonation: this.state.otherDonation,
        priorDonation: this.state.priorDonation,
        priorDonationWhat: this.state.priorDonationWhat,
        contactName: this.state.contactName,
        contactEmail: this.state.contactEmail,
        contactPhone: this.state.contactPhone,
        taxId: this.state.taxId,
      }

      this.props.commonFoundationRequest(foundationData);
      this.props.commonAlert('We have received your submission and will be in touch shortly.', 'Continue');
      this.props.closeMethod();

      this.setState({
        orgName: '',
        orgMission: '',
        eventDescription: '',
        donationUsed: '',
        donationBenefits: '',
        hearAbout: '',
        eventLocationCity: '',
        eventLocationState: '',
        eventLocationVenue: '',
        eventLocationDate: '',
        eventLocationTime: '',
        eventGuestExpected: '',
        otherJewelers: null,
        otherDonation: '',
        priorDonation: null,
        priorDonationWhat: '',
        contactName: '',
        contactEmail: '',
        contactPhone: '',
        taxId: '',

        errorOrgName: false,
        errorOrgMission: false,
        errorEventDescription: false,
        errorDonationUsed: false,
        errorDonationBenefits: false,
        errorHearAbout: false,
        errorEventLocationCity: false,
        errorEventLocationState: false,
        errorEventLocationVenue: false,
        errorEventLocationDate: false,
        errorEventLocationTime: false,
        errorEventGuestExpected: false,
        errorOtherJewelers: false,
        errorOtherDonation: false,
        errorPriorDonation: false,
        errorPriorDonationWhat: false,
        errorContactName: false,
        errorContactEmail: false,
        errorContactPhone: false,
        errorTaxId: false,
      });
    }
  }

	render() {
		return <div className='FoundationRequest'>
      <div className='closeIcon' onClick={::this.props.closeMethod}>
        <div className='closeX'>&times;</div>
      </div>
      <div className='requestTitle'>Donation Request Form</div>
      <div className='requestBr'>
        <img src='https://ddw2.diamondsdirect.com/img/icons/lines/iconline_thin.svg' />
      </div>
      <div className='requestColumn'>
        <div className={'inputWrapper fullWidth'}>
          <div className='inputLabel'>Legal name of your organization:</div>
          <input type='text' onChange={::this.changeOrgName} />
        </div>
        <div className={'inputWrapper fullWidth'}>
          <div className='inputLabel'>The mission of your organization:</div>
          <textarea onChange={::this.changeOrgMission}></textarea>
        </div>
        <div className={'inputWrapper fullWidth'}>
          <div className='inputLabel'>A brief description of the event:</div>
          <textarea onChange={::this.changeOrgDescription}></textarea>
        </div>
        <div className={'inputWrapper fullWidth'}>
          <div className='inputLabel'>How will our donation be used?</div>
          <textarea onChange={::this.changeDonationUsed}></textarea>
        </div>
        <div className={'inputWrapper fullWidth'}>
          <div className='inputLabel'>What promotional benefits would we receive for the requested donation?</div>
          <textarea onChange={::this.changeDonationBenefits}></textarea>
        </div>
        <div className={'inputWrapper fullWidth'}>
          <div className='inputLabel'>How did you hear about the Diamonds Direct Foundation?</div>
          <input type='text' onChange={::this.changeHearAbout} />
        </div>
      </div>
      <div className='requestColumn'>
        
        <div className='inputLabel'>Location of event:</div>        
        <div className={'inputWrapper twoThirdsWidth'}>
          <input type='text' placeholder='City' onChange={::this.changeEventLocationCity} />
        </div>
        <div className={'inputWrapper oneThirdsWidth secondInput'}>
          <input type='text' placeholder='State' onChange={::this.changeEventLocationState} />
        </div>

        <div className={'inputWrapper fullWidth'}>
          <input type='text' placeholder='Venue' onChange={::this.changeEventLocationVenue} />
        </div>

        <div className={'inputWrapper oneThirdsWidth'}>
          <input type='text' placeholder='mm/dd/yyyy' onChange={::this.changeEventLocationDate} />
        </div>
        <div className={'inputWrapper twoThirdsWidth secondInput'}>
          <input type='text' placeholder='5:00pm - 9:00pm' onChange={::this.changeEventLocationTime} />
        </div>

        <div className={'inputWrapper halfWidth'}>
          <div className='inputLabel'># of Guests Expected:</div> 
        </div>
        <div className={'inputWrapper halfWidth secondInput'}>
          <input type='number' onChange={::this.changeEventGuestExpected} />
        </div>

        <div className={'inputWrapper fullWidth'}>
          <div className='inputLabel'>Are any other jewelers participating?</div>
          <div className='radioWrapper'>
            <div className='radioElement'>
              <input type='radio' name='other' value={'Yes'} onChange={::this.changeOtherJewelers} />
              <div className='radioLabel'>Yes</div>
            </div>
            <div className='radioElement'>
              <input type='radio' name='other' value={'No'} onChange={::this.changeOtherJewelers} />
              <div className='radioLabel'>No</div>
            </div>
          </div>
        </div>

        <div className={'inputWrapper fullWidth'}>
          <div className='inputLabel'>If so, what are they donating?</div>
          <input type='text' onChange={::this.changeOtherDonation} />
        </div>

        <div className={'inputWrapper fullWidth'}>
          <div className='inputLabel'>Have we donated to your organization before?</div>
          <div className='radioWrapper'>
            <div className='radioElement'>
              <input type='radio' name='prior' value={'Yes'} onChange={::this.changePriorDonation} />
              <div className='radioLabel'>Yes</div>
            </div>
            <div className='radioElement'>
              <input type='radio' name='prior' value={'No'} onChange={::this.changePriorDonation} />
              <div className='radioLabel'>No</div>
            </div>
          </div>
        </div>

        <div className={'inputWrapper fullWidth'}>
          <div className='inputLabel'>If so, when and what?</div>
          <input type='text' onChange={::this.changePriorDonationWhat} />
        </div>

        <div className='inputLabel'>Contact:</div>        
        <div className={'inputWrapper fullWidth'}>
          <input type='text' placeholder='Name' onChange={::this.changeContactName} />
        </div>

        <div className={'inputWrapper fullWidth'}>
          <input type='email' placeholder='Email' onChange={::this.changeContactEmail} />
        </div>

        <div className={'inputWrapper halfWidth'}>
          <input type='text' placeholder='Phone' onChange={::this.changeContactPhone} />
        </div>
        <div className={'inputWrapper halfWidth secondInput'}>
          <input type='text' placeholder='501c3 Tax ID' onChange={::this.changeTaxId} />
        </div>



      </div>
      <div className='submitWrapper'>
        <div className={'submitButton actionButton'} onClick={::this.submitRequest}>Submit</div>
      </div>
		</div>;
	}
}
export default FoundationRequest;

function mapStateToProps(state) {
  return {
    header: state.header,
  };
}

export const FoundationRequestContainer = connect(
  mapStateToProps,
  allActionCreators
)(FoundationRequest);


// WEBPACK FOOTER //
// ./src/components/views/foundation/FoundationRequest.jsx